import React, { useState } from 'react';
import { Formik } from 'formik';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import Selector from 'react-select';
import { FaSearch, FaCheck, FaTimes, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

export default function FiltrosRelatorio({
  onSubmit,
  isLoading,
  opcoesEmpreendimentos,
  dadosIniciais,
  isLoadingIniciais,
  onEmpreendimentoChange,
}) {
  var optionsEmps = (opcoesEmpreendimentos || []).map(function(item) {
    return {
      value: item.codigo,
      label: item.descricao,
    };
  });

  var _todosSel = useState(false);
  var todosSelecionados = _todosSel[0];
  var setTodosSelecionados = _todosSel[1];

  var _expandido = useState(true);
  var perguntasExpandidas = _expandido[0];
  var setPerguntasExpandidas = _expandido[1];

  var perguntas = dadosIniciais != null ? (dadosIniciais.perguntas || []) : [];
  var isPesquisaAtiva = dadosIniciais != null ? dadosIniciais.is_pesquisa_ativa : false;

  var initialValues = {
    codigo_familia: null,
    data_inicial: '',
    data_final: '',
    respostas_campanha: 'N',
    somente_compra: 'T',
    codigos_perguntas: [],
  };

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Body>
        <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
          {function(formik) {
            var values = formik.values;
            var setFieldValue = formik.setFieldValue;
            var handleSubmit = formik.handleSubmit;

            var handleEmpChange = function(option) {
              var val = option ? option.value : null;
              setFieldValue('codigo_familia', val);
              setFieldValue('codigos_perguntas', []);
              setFieldValue('respostas_campanha', 'N');
              setFieldValue('somente_compra', 'T');
              setTodosSelecionados(false);
              onEmpreendimentoChange(val, values.data_inicial, values.data_final);
            };

            var handleToggleTodos = function() {
              if (todosSelecionados) {
                setFieldValue('codigos_perguntas', []);
                setTodosSelecionados(false);
              } else {
                setFieldValue('codigos_perguntas', perguntas.map(function(p) { return p.codigo; }));
                setTodosSelecionados(true);
              }
            };

            var handleCheckPergunta = function(codigo) {
              var current = values.codigos_perguntas || [];
              var exists = current.indexOf(codigo) !== -1;
              if (exists) {
                setFieldValue('codigos_perguntas', current.filter(function(c) { return c !== codigo; }));
              } else {
                setFieldValue('codigos_perguntas', current.concat([codigo]));
              }
            };

            return (
              <Form onSubmit={handleSubmit}>
                <Row className="align-items-end mb-2">
                  <Col xs={12} md={3}>
                    <Form.Group>
                      <Form.Label>Empreendimento:</Form.Label>
                      <Selector
                        styles={customStyles}
                        components={{ DropdownIndicator: DropdownIndicator }}
                        options={optionsEmps}
                        isClearable
                        placeholder="Selecione um empreendimento..."
                        value={optionsEmps.find(function(o) { return o.value === values.codigo_familia; }) || null}
                        onChange={handleEmpChange}
                        noOptionsMessage={function() { return 'Nenhum empreendimento encontrado'; }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6} md={2}>
                    <Form.Group>
                      <Form.Label>De:</Form.Label>
                      <Form.Control
                        type="date"
                        value={values.data_inicial}
                        onChange={function(e) { setFieldValue('data_inicial', e.target.value); }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6} md={2}>
                    <Form.Group>
                      <Form.Label>Ate:</Form.Label>
                      <Form.Control
                        type="date"
                        value={values.data_final}
                        onChange={function(e) { setFieldValue('data_final', e.target.value); }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3}>
                    <Form.Group>
                      <Form.Label>Tipo de Pesquisa:</Form.Label>
                      <Selector
                        styles={customStyles}
                        components={{ DropdownIndicator: DropdownIndicator }}
                        options={[
                          { value: 'N', label: 'Respostas Corretores (Extranet)' },
                          { value: 'S', label: 'Respostas Clientes (Validacao Cadastro)' },
                        ]}
                        value={[
                          { value: 'N', label: 'Respostas Corretores (Extranet)' },
                          { value: 'S', label: 'Respostas Clientes (Validacao Cadastro)' },
                        ].find(function(o) { return o.value === values.respostas_campanha; })}
                        isDisabled={!isPesquisaAtiva}
                        onChange={function(option) { setFieldValue('respostas_campanha', option ? option.value : 'N'); }}
                        noOptionsMessage={function() { return 'Nenhuma opcao encontrada'; }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={2}>
                    <Form.Group>
                      <Form.Label>Apenas c/ Compra:</Form.Label>
                      <Selector
                        styles={customStyles}
                        components={{ DropdownIndicator: DropdownIndicator }}
                        options={[
                          { value: 'T', label: 'Todos' },
                          { value: 'N', label: 'Nao' },
                          { value: 'S', label: 'Sim' },
                        ]}
                        value={[
                          { value: 'T', label: 'Todos' },
                          { value: 'N', label: 'Nao' },
                          { value: 'S', label: 'Sim' },
                        ].find(function(o) { return o.value === values.somente_compra; })}
                        isDisabled={!isPesquisaAtiva}
                        onChange={function(option) { setFieldValue('somente_compra', option ? option.value : 'T'); }}
                        noOptionsMessage={function() { return 'Nenhuma opcao encontrada'; }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {perguntas.length > 0 && (
                  <Card className="mb-3">
                    <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff' }} className="d-flex justify-content-between align-items-center py-2">
                      <span style={{ fontSize: '0.9rem', fontWeight: 600}}>Campos do Personalizado</span>
                      <div>
                        <Button
                          variant={todosSelecionados ? 'danger' : 'success'}
                          size="sm"
                          className="mr-1"
                          onClick={handleToggleTodos}
                          title={todosSelecionados ? 'Desmarcar todos' : 'Selecionar todos'}
                        >
                          {todosSelecionados ? <FaTimes /> : <FaCheck />}
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          onClick={function() { setPerguntasExpandidas(!perguntasExpandidas); }}
                          title={perguntasExpandidas ? 'Minimizar' : 'Expandir'}
                        >
                          {perguntasExpandidas ? <FaChevronUp /> : <FaChevronDown />}
                        </Button>
                      </div>
                    </Card.Header>
                    {perguntasExpandidas && (
                    <Card.Body className="py-2">
                      <Row>
                        {perguntas.map(function(p) {
                          var isChecked = (values.codigos_perguntas || []).indexOf(p.codigo) !== -1;
                          return (
                            <Col xs={12} md={4} key={p.codigo} className="mb-1">
                              <Form.Check
                                type="switch"
                                id={'pergunta-' + p.codigo}
                                label={p.descricao}
                                checked={isChecked}
                                onChange={function() { handleCheckPergunta(p.codigo); }}
                              />
                            </Col>
                          );
                        })}
                      </Row>
                    </Card.Body>
                    )}
                  </Card>
                )}

                <Row>
                  <Col xs={12} md={3} className="offset-md-4">
                    <Button
                      type="submit"
                      variant="success"
                      block
                      disabled={isLoading || isLoadingIniciais}
                    >
                      <FaSearch /> Mostrar Relatorio
                    </Button>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </Card.Body>
    </Card>
  );
}
